import { checkDeviceNow } from '../../device/gate'
import { Icon } from '../../components/Icon'
import { useConnection } from '../../state/connection'
import { useDeviceGate } from '../../state/device'
import { DeviceGateLayout } from './DeviceGateLayout'

export function DevicePendingScreen() {
  const checking = useDeviceGate((s) => s.checking || s.attesting)
  const registered = useDeviceGate((s) => Boolean(s.device.code))
  const online = useConnection((s) => s.online)

  return (
    <DeviceGateLayout
      icon="lock"
      title="Waiting for approval"
      tone="waiting"
      actions={
        <button type="button" className="button primary" disabled={checking || !online} onClick={() => void checkDeviceNow()}>
          <Icon name="refresh" />
          {checking ? 'Checking…' : 'Check again'}
        </button>
      }
    >
      <p>
        {registered
          ? 'This device needs to be approved before you can use BOSS Chat. Ask a system administrator to approve it and give them this code:'
          : 'This device needs to be approved before you can use BOSS Chat. Registering it now…'}
      </p>
      <p className="device-auto-check" role="status" aria-live="polite">
        <span className={checking ? 'device-pulse active' : 'device-pulse'} aria-hidden="true" />
        {online ? (checking ? 'Checking now' : 'Checking automatically') : "You're offline. We'll check when you're back online."}
      </p>
    </DeviceGateLayout>
  )
}
